module.exports = __webpack_public_path__ + "img/bottomBg.6f044fd6.png";